module.exports = __webpack_public_path__ + "static/media/showcase-img3.9cc33b5f.jpg";